<template>
  <div class="preview-data">
    <SelectedCompany class="mb-2" :class="{ 'justify-center': vertical }" />
    <div
      class="d-flex align-center flex-wrap"
      :class="[vertical ? 'flex-column' : 'flex-row']"
    >
      <div class="data-row" v-if="showType">
        <div class="label">{{ $t("message.permissions.accountType") }}:</div>
        <div class="value">
          {{ $t(`message.permissions.accountTypes.${member.type}`) }}
          <ui-button
            text
            class="link-btn"
            v-if="editMode"
            @click="showMembersDialog"
          >
            {{ buttonLabel }}
          </ui-button>
        </div>
      </div>
      <div class="data-row" v-if="showEmail">
        <div class="label">{{ $t("message.permissions.email") }}:</div>
        <div class="value">
          {{ member.email }}
        </div>
      </div>
    </div>
    <div class="d-flex flex-column" :class="{ 'align-center': vertical }">
      <div class="data-row" v-if="showCount">
        <div class="label">{{ $t("message.permissions.accessTo") }}:</div>
        <div class="value">
          {{ facilitiesCount }}
          <ui-button
            text
            class="link-btn"
            v-if="
              (editMode || previewMode) && member.type !== accountTypes.ADMIN
            "
            @click="showFacilitiesDialog"
          >
            {{ buttonLabel }}
          </ui-button>
        </div>
      </div>
      <div class="data-row" v-if="showPermissions">
        <div class="label">{{ $t("message.permissions.permissions") }}:</div>
        <div class="value">
          {{
            member.type === accountTypes.ADMIN
              ? $t("message.permissions.allPermissions")
              : $t("message.permissions.limitedPermissions")
          }}
        </div>
      </div>
    </div>

    <v-divider v-if="divider"></v-divider>
  </div>
</template>

<script>
import SelectedCompany from "@/components/Permissions/SelectedCompany";
import { mapGetters, mapState } from "vuex";
import { pluralCount } from "@/helpers/helpers";
import { AccountType } from "@/enums/account-type";
import { companyMember } from "@/helpers/mixins/company-member";
import { PermissionsActiveDialog } from "@/enums/permissions-active-dialog";

export default {
  name: "PreviewData",
  components: {
    SelectedCompany
  },
  mixins: [companyMember],
  props: {
    showType: Boolean,
    showEmail: Boolean,
    showCount: Boolean,
    showPermissions: Boolean,
    divider: Boolean,
    vertical: Boolean
  },
  computed: {
    facilitiesCount() {
      return this.$store.getters["permissions/facilitiesGroupsCount"]
        ? `${pluralCount(
            "message.pluralForms.group",
            this.$store.getters["permissions/facilitiesGroupsCount"]
          )} / ${pluralCount(
            "message.pluralForms.facility",
            this.$store.getters["permissions/facilitiesCount"]
          )}`
        : pluralCount(
            "message.pluralForms.facility",
            this.$store.getters["permissions/facilitiesCount"]
          );
    },
    buttonLabel() {
      if (this.previewMode) {
        return this.$t("message.permissions.see");
      }

      return this.$t("message.common.change");
    }
  },
  methods: {
    showMembersDialog() {
      this.setActiveDialog(PermissionsActiveDialog.MEMBERS, this.mode);
    },
    showFacilitiesDialog() {
      this.setActiveDialog(PermissionsActiveDialog.FACILITIES, this.mode);
    }
  }
};
</script>

<style lang="scss" scoped>
.preview-data {
  .data-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: $spacing $spacing * 3 $spacing 0;
  }

  .label,
  .value {
    font-weight: 500;
    @include font-size(14px);
    line-height: 17px;
    color: $text;
  }

  .label {
    opacity: 0.4;
    margin-right: $spacing;
  }

  .link-btn .v-btn__content {
    @include font-size(14px);
    line-height: 17px;
    color: $text;
    font-weight: 600;
  }
}
</style>
